import React from "react";
import { Dialog } from "@headlessui/react";
import { Separate } from "components/ui";

interface Props {
  link: any;
}

const PersonalInfo: React.FC<Props> = ({ link }) => {
  return (
    <>
      <Dialog.Title
        as="h3"
        className="text-gray-900 pb-4 text-center text-xl font-medium leading-6"
      >
        Personal Information
      </Dialog.Title>
      <Separate dark={true} />
      <div className="space-y-3 pt-4">
        <div className="flex justify-between rounded-lg bg-cultured p-4 font-roboto text-base font-medium">
          <div className="text-philippine-gray">DOB</div>
          <div>{JSON.parse(link.link_value).dob}</div>
        </div>
        <div className="flex justify-between rounded-lg bg-cultured p-4 font-roboto text-base font-medium">
          <div className="text-philippine-gray">Blood Type</div>
          <div>{JSON.parse(link.link_value).bloodType}</div>
        </div>
      </div>
    </>
  );
};

export default PersonalInfo;
